import React from 'react';
import { MessageCircleIcon, UsersIcon, FileTextIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-20 lg:py-28 bg-tlfc-stone" data-id="element-230">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-231">
        {/* Section Header */}
        <div className="reveal text-center max-w-2xl mx-auto" data-id="element-232">
          <h2 className="font-serif text-3xl md:text-4xl text-tlfc-text" data-id="element-233">
            How it works
          </h2>
          <p className="mt-3 text-tlfc-text-secondary text-lg" data-id="element-234">
            From first contact to resolution — here's what to expect.
          </p>
        </div>

        {/* Steps */}
        <div className="reveal-stagger mt-14 grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6" data-id="element-235">
          {/* Step 1 */}
          <div className="text-center relative" data-id="element-236">
            <div className="w-12 h-12 rounded-full bg-tlfc-gold/10 flex items-center justify-center mx-auto" data-id="element-237">
              <span className="text-tlfc-gold font-semibold text-sm" data-id="element-238">1</span>
            </div>
            <div className="mt-4 w-10 h-10 rounded-full bg-white border border-tlfc-border flex items-center justify-center mx-auto shadow-soft" data-id="element-239">
              <MessageCircleIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-240" />
            </div>
            <h3 className="mt-4 font-medium text-tlfc-text" data-id="element-241">
              Tell us your situation
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-242">
              Call, email, or start online. We'll listen and understand your
              needs.
            </p>
            {/* Connector line - desktop only */}
            <div className="hidden md:block absolute top-6 left-[60%] w-[80%] border-t border-dashed border-tlfc-border" data-id="element-243" />
          </div>

          {/* Step 2 */}
          <div className="text-center relative" data-id="element-244">
            <div className="w-12 h-12 rounded-full bg-tlfc-gold/10 flex items-center justify-center mx-auto" data-id="element-245">
              <span className="text-tlfc-gold font-semibold text-sm" data-id="element-246">2</span>
            </div>
            <div className="mt-4 w-10 h-10 rounded-full bg-white border border-tlfc-border flex items-center justify-center mx-auto shadow-soft" data-id="element-247">
              <UsersIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-248" />
            </div>
            <h3 className="mt-4 font-medium text-tlfc-text" data-id="element-249">
              We match you with a specialist
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-250">
              You'll work with a lawyer who has deep expertise in your area.
            </p>
            <div className="hidden md:block absolute top-6 left-[60%] w-[80%] border-t border-dashed border-tlfc-border" data-id="element-251" />
          </div>

          {/* Step 3 */}
          <div className="text-center relative" data-id="element-252">
            <div className="w-12 h-12 rounded-full bg-tlfc-gold/10 flex items-center justify-center mx-auto" data-id="element-253">
              <span className="text-tlfc-gold font-semibold text-sm" data-id="element-254">3</span>
            </div>
            <div className="mt-4 w-10 h-10 rounded-full bg-white border border-tlfc-border flex items-center justify-center mx-auto shadow-soft" data-id="element-255">
              <FileTextIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-256" />
            </div>
            <h3 className="mt-4 font-medium text-tlfc-text" data-id="element-257">
              Get a clear plan
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-258">
              We'll outline your options, likely outcomes, and transparent
              costs.
            </p>
            <div className="hidden md:block absolute top-6 left-[60%] w-[80%] border-t border-dashed border-tlfc-border" data-id="element-259" />
          </div>

          {/* Step 4 */}
          <div className="text-center" data-id="element-260">
            <div className="w-12 h-12 rounded-full bg-tlfc-gold/10 flex items-center justify-center mx-auto" data-id="element-261">
              <span className="text-tlfc-gold font-semibold text-sm" data-id="element-262">4</span>
            </div>
            <div className="mt-4 w-10 h-10 rounded-full bg-white border border-tlfc-border flex items-center justify-center mx-auto shadow-soft" data-id="element-263">
              <CheckCircleIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-264" />
            </div>
            <h3 className="mt-4 font-medium text-tlfc-text" data-id="element-265">We handle it</h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-266">
              From strategy to resolution, we manage every detail so you don't
              have to.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="reveal mt-12 text-center" data-id="element-267">
          <a href="#contact" className="inline-flex items-center gap-2 px-6 py-3 bg-tlfc-gold text-white font-medium rounded-lg hover:bg-tlfc-gold-light transition-colors shadow-sm group" data-id="element-268">
            Start with a free initial conversation
            <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-269" />
          </a>
        </div>
      </div>
    </section>;
}